import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0,
    olddata:{}
    
}
const mutations={
   
    getExpressIndex(state,value){
        
        
       
        post(urls.admin.express.index,value).then((result)=>{
          
          
          
          state.result=result
          state.olddata=result

        
       
           
        });
        
    },
    editOrderExpress(state,value){



        post(urls.admin.express.edit,value).then((result)=>{


            state.olddata["code"]=result.code
            state.result=result




        });

    },



  

 

}
const  actions={


    getExpressIndexAction(context,value){
       
        context.commit("getExpressIndex",value)
       
    },
    editOrderExpressAction(context,value){

        context.commit("editOrderExpress",value)

    },
  
  

    

}

export default {state,mutations,actions}